import { React, ts } from '_core';

import Chart from './chart';

type AlphaModelAverageCorrelationProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  fullScreen: boolean;
  context?: ts.types.signal.SignalAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'optimized_alpha_model_correlation', string>;

  title: string;
};

const lphaModelAverageCorrelation = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  fullScreen,
  widgetPaths,
  context,
  title,
}: AlphaModelAverageCorrelationProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      fullScreen={fullScreen}
      loadWidgetData={loadWidgetData}
      definition={
        (context.definition as ts.types.signal.AlphaDefinition)?.json_definition as ts.types.signal.OptimizedModel
      }
      optimizedCovariance={widgetPaths['optimized_alpha_model_correlation']}
      title={title}
    />
  );
};

export default lphaModelAverageCorrelation;
